import React from "react";
import {store} from "../../Redux/store"
import { AppProvider } from "../Provider";
import { CustomCallComponent } from "./CustomCallComponent";
import PropTypes from 'prop-types';

export const  MirrorflyCall = (props = {})=>{
    const {  width = "",  height = "" , enableDeviceSize = false } = props
    return (
    <AppProvider store={store}>
        <div id="mf-root-Parent" style={{ width: width ? width  : "100%",   height: height ? height : "100%" }}>
        <CustomCallComponent 
            userId = {props.userId}
            callType={props.callType} 
            endCallAction={props.endCall}
            enableDeviceSize = {(width || height) ? false : enableDeviceSize}
            enableMobileView={props.enableMobileView}
            colorSet={props.colorSet}
        />
        </div>
    </AppProvider>
    );
}

MirrorflyCall.propTypes ={
    userId:PropTypes.array.isRequired,
    callType:PropTypes.string.isRequired,
    colorSet:PropTypes.object,
    iconSet:PropTypes.object,
    width:PropTypes.string,
    height:PropTypes.string,
    enableMobileView:PropTypes.bool,
    enableDeviceSize:PropTypes.bool,
}

